module.exports = __webpack_public_path__ + "static/media/ArchitectsDaughter-Regular.31c2153c.ttf";